import ChatButton from '@/components/chatButton';
import DraggableButton from '@/components/DraggableButton';
import Spinner from '@/components/spinner';
import { getMessageCount } from '@/utils/api';
import { useEffect, useRef, useState } from 'react';
import ChatContainers from '../chatContainers';
import {
  ChatBeginButton,
  ChatBeginButtonContainer,
  ChatCloseButton,
  ChatCloseButtonContainer,
  ChatInvitationBody,
  ChatMessageContainer,
} from './styled.js';
// 引入一个音频
// 终极方法
const useGetState = (initVal) => {
  const [state, setState] = useState(initVal);
  const ref = useRef(initVal);
  const setStateCopy = (newVal) => {
    ref.current = newVal;
    setState(newVal);
  };
  const getState = () => ref.current;
  return [state, setStateCopy, getState];
};

let intervalObj = null;
let isUsed = false;
const ChatMain = (props) => {
  const [showWidget, setShowWidget] = useState(false);
  const [toggleIcon, setToggleIcon, getToggleIcon] = useGetState(false);
  const [invitation, setInvitation] = useState(false);
  const [timeOutObj, setTimeOutObj] = useState('');
  const [chatConfig, setChatConfig] = useState(props.config);
  const [agentDisabled, setAgentDisabled] = useState(false);
  const [agentInput, setAgentInput] = useState(false);
  const forChangeInfo = (data) => {
    setChatConfig({
      ...chatConfig,
      ...data,
    });
    handleClickEndChat();
    // console.log('chatConfig>>>', chatConfig);
  };
  window.forChangeInfo = forChangeInfo;
  // 设备类型，mobile/pc
  let device = props.device;
  useEffect(() => {
    // 实现mobile下livechat定位的css，并保存原网页css关闭后还原，避免错乱
    if (device === 'mobile' && (chatConfig.isHomepage || chatConfig.useNewMobileChat)) {
      localStorage.setItem(
        'LiveChatBodyStyle',
        JSON.stringify({
          position: document.body.style,
          width: document.body.width,
          height: document.body.style.height,
          margin: document.body.style.margin,
        })
      );
      if (toggleIcon) {
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
        document.body.style.margin = '0';
      } else {
        let originStyle = JSON.parse(localStorage.getItem('LiveChatBodyStyle'));
        document.body.style = {
          ...document.body.style,
          ...originStyle,
        };
      }
    }
  }, [toggleIcon]);
  // 判断如果是PC端，并且设置了自动唤起时间
  if (device === 'pc' && chatConfig.chatInviteProactivelyFlag === '1' && !isUsed && !getToggleIcon()) {
    if (getToggleIcon()) {
      return;
    }
    // 间隙时间
    let wakeInterval = Number(chatConfig.chatAutomaticWakeInterval) * 1000;
    setTimeout(function () {
      if (!getToggleIcon()) {
        // 打开邀请信息
        setInvitation(true);
        isUsed = true;
      }
    }, wakeInterval);
  }

  const [messageCount, setMessageCount] = useState(0);
  const intervalRef = useRef(null);

  const setAgentDisabledValue = () => {
    return chatConfig.chatOpenChannelType === '1' || chatConfig.chatOpenChannelType === '3';
  };
  useEffect(() => {
    setAgentDisabled(setAgentDisabledValue());
  }, []);
  const playTipAudio = () => {
    let audio = document.getElementById('notificationSound');
    audio.play();
  };
  // 轮训获取消息数量 30s
  const trainGetMessageCount = async (e) => {
    // console.log('trainGetMessageCount', e);
    // console.log('invitation', invitation);
    // console.log('toggleIcon', getToggleIcon());
    // console.log('isSmallWindow', isSmallWindow);
    let imChatSessionId = localStorage.getItem('imChatSessionId');
    // console.log('imChatSessionId', imChatSessionId);
    if (imChatSessionId == undefined || imChatSessionId == null) {
      return;
    }
    if (imChatSessionId) {
      // console.log('轮训获取消息数量');
      let params = {
        companyId: chatConfig.companyId,
        sessionId: imChatSessionId,
        role: 'customer',
      };
      const getCount = await getMessageCount(params);
      // console.log('getCount', getCount);
      let inProgress = localStorage.getItem('inProgress');
      if (e < getCount?.data?.count && e != getCount?.data?.count && getCount?.data?.count > 0) {
        // console.log('playTipAudio', e, getCount?.data?.count);
        playTipAudio();
      }
      setMessageCount(getCount?.data?.count ?? 0);
      window.unReadMesaggeCount.count = getCount?.data?.count ?? 0;
      if (getCount?.data.status != 0 && (inProgress == null || !getToggleIcon())) {
        clearTimeout(timeOutObj);
        setTimeOutObj(
          setTimeout(() => {
            trainGetMessageCount(getCount?.data?.count ?? 0);
          }, 10000)
        );
      }
    }
  };
  const clearMessageCount = () => setMessageCount(0);
  const handleEndChatFromParent = () => {
    // 重置消息数量
    setMessageCount(0);
    localStorage.removeItem('imChatSessionId');
  };
  useEffect(() => {
    clearTimeout(timeOutObj);
    trainGetMessageCount(0);
  }, []);

  useEffect(() => {
    if (device === 'mobile' && (!chatConfig.isHomepage || !chatConfig.useNewMobileChat)) {
      setToggleIcon(true);
    }
    if (chatConfig.fullScreen) {
      setToggleIcon(true);
    }
  }, []);

  // 监听toggleIcon的变化
  useEffect(() => {
    setMessageCount(0);
    clearTimeout(timeOutObj);
    // 处理toggleIcon状态发生变化后的处理
    if (toggleIcon) {
      setShowWidget(true);
      if (!isUsed) {
        isUsed = true;
      }
    } else {
      setShowWidget(false);
      trainGetMessageCount(0);
    }
  }, [toggleIcon]);

  const handleOpenWindow = () => {
    setToggleIcon(true);
    setInvitation(false);
  };
  const handleCloseInvitation = () => {
    setInvitation(false);
  };

  return (
    <div>
      {/* <h2>SSE 连接状态: {connected ? '已连接 ✅' : '断开 ❌'}</h2>
      <ul>
        {messages.map((msg, idx) => (
          <li key={idx}>{msg}</li>
        ))}
      </ul> */}
      {/* 可拖动按钮 */}
      {chatConfig.enableConfigTool && <DraggableButton device={device} />}
      {/* 我想在这里增加一个音频 */}
      <audio
        style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%' }}
        id="notificationSound"
        src={process.env.tipMp3Url}
        preload="auto"
      ></audio>
      {device == 'mobile' && (chatConfig.isHomepage || chatConfig.useNewMobileChat) && toggleIcon && (
        <div
          style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: 100, background: 'rgba(0,0,0,0.3)' }}
          onClick={() => {
            setToggleIcon(false);
            // handleClickEndChat();
          }}
        ></div>
      )}
      {chatConfig !== null ? (
        <div style={{ marginTop: 20 }}>
          {device === 'pc' && chatConfig.fullScreen == false ? (
            <ChatButton
              chatIconClose={chatConfig.chatIconClose}
              chatIconOpen={chatConfig.chatIconOpen}
              toggleIcon={toggleIcon}
              setToggleIcon={setToggleIcon}
              chatConfig={chatConfig}
              count={messageCount}
            />
          ) : (
            (chatConfig.isHomepage || chatConfig.useNewMobileChat) &&
            !toggleIcon && (
              <ChatButton
                chatIconClose={chatConfig.chatIconClose}
                chatIconOpen={chatConfig.chatIconOpen}
                toggleIcon={toggleIcon}
                setToggleIcon={setToggleIcon}
                chatConfig={chatConfig}
                count={messageCount}
              />
            )
          )}
          {device === 'pc' && !isUsed && invitation ? (
            <ChatInvitationBody className={chatConfig.fullScreen ? 'fullScreen' : ''}>
              <ChatCloseButtonContainer $themecolor={chatConfig.chatThemeColor}>
                <ChatCloseButton onClick={handleCloseInvitation} $chatServiceColor={chatConfig.chatServiceColor}>
                  {CLoseIcon(chatConfig.chatThemeColor)}
                </ChatCloseButton>
              </ChatCloseButtonContainer>
              <ChatMessageContainer
                onClick={handleOpenWindow}
                $chatservicecolor={chatConfig.chatServiceColor}
                $chatmessagecolor={chatConfig.chatMessageColor}
              >
                {chatConfig.popWelcomeMsg}
              </ChatMessageContainer>
              <ChatBeginButtonContainer>
                <ChatBeginButton $themecolor={chatConfig.chatThemeColor} onClick={handleOpenWindow}>
                  {chatConfig.chatSubmit}
                </ChatBeginButton>
              </ChatBeginButtonContainer>
            </ChatInvitationBody>
          ) : (
            ''
          )}
          <ChatContainers
            setAgentInput={setAgentInput}
            agentInput={agentInput}
            $fullScreen={chatConfig.fullScreen}
            device={device}
            chatConfig={chatConfig}
            showWidget={showWidget}
            toggleIcon={toggleIcon}
            setToggleIcon={setToggleIcon}
            onEndChat={handleEndChatFromParent}
            agentDisabled={agentDisabled}
            setAgentDisabled={setAgentDisabled}
            trainGetMessageCount={trainGetMessageCount}
            playTipAudio={playTipAudio}
            clearMessageCount={clearMessageCount}
          />
        </div>
      ) : (
        <Spinner error={'未获取到配置信息，请检查配置或联系管理员'} />
      )}
    </div>
  );
};

const CLoseIcon = (color) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.8924 5.62689L8.51886 8.00023L10.8924 10.3745C11.0359 10.5171 11.0359 10.7492 10.8924 10.8928C10.8207 10.9646 10.7275 11 10.6334 11C10.5394 11 10.4462 10.9646 10.3745 10.8928L8 8.51853L5.62552 10.8919C5.5538 10.9636 5.46064 10.9991 5.36656 10.9991C5.2734 10.9991 5.17932 10.9636 5.10759 10.8919C4.96414 10.7492 4.96414 10.5171 5.10759 10.3736L7.48114 7.9993L5.10759 5.62596C4.96414 5.48334 4.96414 5.25122 5.10759 5.10767C5.25012 4.96411 5.48207 4.96411 5.62552 5.10767L8 7.48101L10.3745 5.1086C10.517 4.96504 10.749 4.96504 10.8924 5.1086C11.0359 5.25122 11.0359 5.48334 10.8924 5.62689Z"
    />
  </svg>
);

export default ChatMain;
